import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import logoImage from '../../Assest/logo.png';
import './Login.css'
import { Toast } from 'primereact/toast';
import { Api } from '../../services/api';
import axios from 'axios';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";

const Login = ({ handleLogin, onLoginSuccess }) => {

  const toast = useRef(null);
  const { instance, inProgress, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (accounts.length > 0 && !localStorage.getItem('isLogin')) {
      const account = accounts[0];
      const { name, username } = account;
      // You might want to get an access token silently here if needed, but for now we just log in based on account presence.
            
      // Attempt to acquire token silently to store it
      instance.acquireTokenSilent({
          ...loginRequest,
          account: account
      }).then((response) => {
          
          if (!toast.current) return;
          // Authenticate with Backend using the Microsoft Account Email
          axios.post(Api.API_BASE_URL + 'microsoft-login', { email: username })
            .then(res => {
                const data = res.data;
                if (data.token) {
                    localStorage.setItem('authToken', data.token); // Store the BACKEND token
                    localStorage.setItem('isLogin', true);
                    localStorage.setItem('isLoggedIn', true); // Added for compatibility
                    localStorage.setItem('email', username);
                    
                    const user = data.data; // User object from backend
                    
                    if (user) {
                        localStorage.setItem('user_id', user._id);
                        
                        // Handle role_id
                        const rId = user.role_id?._id || user.role_id;
                        localStorage.setItem('role_id', rId);
                        
                        // Role metadata
                        localStorage.setItem('role_name', user.role_name || user.role_id?.name || 'User');
                        localStorage.setItem('permission_role', user.role_id?.permission_role || '');
                        localStorage.setItem('isAdmin', user.isAdmin || user.role_id?.isAdmin || false);
                        
                        // Organization metadata
                        if (user.organizationId) {
                            localStorage.setItem('organizationId', user.organizationId._id || user.organizationId);
                            localStorage.setItem('organizationName', user.organizationId.title || '');
                            localStorage.setItem('organizationLogo', user.organizationId.image || '');
                        }

                        // User metadata
                        const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim() || name;
                        localStorage.setItem('name', fullName);
                        if(user.image) localStorage.setItem('image', user.image);
                        
                        // Legacy roles fields just in case
                        localStorage.setItem('roles', user.roles || []);
                        localStorage.setItem('rolesList', user.rolesList || []);

                        toast.current.show({ severity: 'success', summary: 'Login Complete', detail: 'Authenticated successfully' });

                        if (onLoginSuccess) {
                            onLoginSuccess();
                        }
                
                        setTimeout(() => {
                            navigate('/');
                        }, 1000);
                    }
                }
            })
            .catch(err => {
                console.error("Backend authentication failed:", err);
                const errorMessage = err.response?.data?.error || 'User not registered in the system.';
                toast.current.show({ severity: 'error', summary: 'Access Denied', detail: errorMessage, life: 5000 });
                
                // Clear local storage and logout from Microsoft if user is not found in backend
                localStorage.clear();
                setTimeout(() => {
                    instance.logoutRedirect().catch(e => console.error(e));
                }, 3000);
            });

      }).catch((e) => {
          console.error("Silent token acquisition failed", e);
          // If silent fails, maybe just use ID token info or prompt login again, but for now let's hope it works or user is already in a session.
      });
    }
  }, [accounts, instance, navigate, onLoginSuccess]);

  const handleMicrosoftLogin = () => {
      if (inProgress === InteractionStatus.None) {
          instance.loginRedirect({
            ...loginRequest,
            prompt: "select_account"
          }).catch(e => {
              console.error(e);
              toast.current.show({ severity: 'error', summary: 'Login Failed', detail: e.message });
          });
      } else {
        console.log("Interaction in progress, waiting...");
      }
  };
  const [orgType, setOrgType] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add submitting state

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    organization: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted');
    setIsSubmitting(true); // Disable button

    const url = `${Api.API_BASE_URL}dologin`;

    try {
      console.log(formData.organization);
      formData.organization = selectedItem;
      const response = await fetch(url, {
        method: "POST",
        headers: Api.headers,
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error) {
        console.log('Error:', data.error);
        toast.current.show({ severity: 'error', detail: data.error });
      } else {
        const { _id, email, first_name, last_name, role_id, name, permission_role, image, roles, rolesList, organizationId } = data.data;
        const token = data.token;
        console.log('user--details', data)
        localStorage.setItem('authToken', token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
        toast.current.show({ severity: 'success', detail: data.message });
        console.log("data result", data.message)
        localStorage.setItem('isLogin', true);
        localStorage.setItem('isLoggedIn', true);
        localStorage.setItem('user_id', _id);
        localStorage.setItem('email', email);
        localStorage.setItem('name', `${first_name} ${last_name}`);
        localStorage.setItem('role_id', role_id._id);
        localStorage.setItem('role_name', name);
        localStorage.setItem('permission_role', role_id.permission_role);
        localStorage.setItem('image', image);
        localStorage.setItem('roles', roles);
        localStorage.setItem('rolesList', rolesList);
        localStorage.setItem('organizationId', organizationId._id)
        localStorage.setItem('organizationName', organizationId.title)
        localStorage.setItem('organizationLogo', organizationId.image)
        localStorage.setItem('isAdmin', role_id.isAdmin)

        if (data.data.role_id !== 1 && data.data.role_id !== 2) {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        } else {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.current.show({ severity: 'error', detail: 'An error occurred during the login process.' });
    }finally {
      setIsSubmitting(false); // Re-enable the button after submission
    }
  };

  useEffect(() => {
    // console.log('Fetching org...xx');
    getOrgType();
  }, []);

  const getOrgType = (org) => {


    axios.get(Api.API_BASE_URL + 'get-active-organization')
      .then((response) => {
        const data = response.data.result;
        setOrgType(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching org:', error);
        setIsLoading(false);
      });
  };



  // Call the async function



  const [selectedItem, setSelectedItem] = useState(null);
  // const items = Array.from({ length: 20 }).map((_, i) => ({ label: `Organization #${i+1}`, value: i }));

  return (
    <div className="login-shell">
      <Toast ref={toast} />
      <div className="login-card">
        <div className="login-brand">
          <div className="logo-glow"></div>
          <img src={logoImage} alt="Builder Playbook" className='img-class' />
          <div>
            <strong>Builder Playbook</strong>
            <p className="brand-subtitle">Strategy | Execution | Performance</p>
          </div>
        </div>

        <h1>Welcome back</h1>
        <p className="text-muted">Sign in to continue to the Builder Playbook workspace.</p>

        <form onSubmit={handleSubmit}>
          <label className='login-label'>Email</label>
          <input className='input-log' type="email" placeholder="you@email.com" name="username" value={formData.username} onChange={handleInputChange} required />

          <label className='login-label'>Password</label>
          <div className="password-container">
            <input
              className='input-log'
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span className="toggle-password" onClick={togglePasswordVisibility}>
              {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
            </span>
          </div>

          <button className='button-login' type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Logging in..." : "Login"}
          </button>
        </form>
        
        <div style={{ textAlign: "center", margin: "10px 0", color: "#666" }}>OR</div>
        
        <button
          className='button-login' 
          type="button" 
          onClick={handleMicrosoftLogin}
          disabled={inProgress !== InteractionStatus.None}
          style={{ backgroundColor: '#2F2F2F', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', opacity: inProgress !== InteractionStatus.None ? 0.7 : 1, cursor: inProgress !== InteractionStatus.None ? 'not-allowed' : 'pointer' }}
        >
            <i className="pi pi-microsoft" style={{ fontSize: '1.2rem' }}></i>
            {inProgress === InteractionStatus.None ? "Sign in with Microsoft" : "Signing in..."}
        </button>

        <div className="login-footer">
          <span>Need help? <Link to="/forget-password">Forgot password</Link></span>
          <span className="text-muted small">Secure access secured by PrimeReact</span>
        </div>
      </div>
    </div>
  );
};

export default Login;